import { SurveyResultsFilterNames } from 'models';
import { IFiltersToReset } from 'modules/admin-panel/pages/results/models';
import { TFunction } from 'i18next';

export const getFiltersToResetList = (
	t: TFunction,
	filtersToReset?: IFiltersToReset,
) => {
	if (!filtersToReset) return '';
	return Object.keys(filtersToReset)
		.map((f) => {
			if (f === SurveyResultsFilterNames.businessUnit) {
				return t('titles.business_unit');
			}
			if (f === SurveyResultsFilterNames.roleId) {
				return t('titles.role');
			}

			if (f === 'statisticGroupingType') {
				return t('grouping_type');
			}
			return t(f);
		})
		.join(', ');
};
